import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import API from "../api";
import { SELECTED_LANGUAGE_PREFIX, USER_TOKEN } from "../constants";
import { LanguageTranslateValues } from "../models/language.translate.values";

import en_US from "./locales/en_US";
import pt_BR from "./locales/pt_BR";
import es_ES from "./locales/es_ES";
import it_IT from "./locales/it_IT";
import fr_FR from "./locales/fr_FR";
import zh_CN from "./locales/zh_CN";

export const i18nInit = async (activeLanguageId?: number, defaultLanguageId?: number) => {
  let language = null;
  let languageTranslations: LanguageTranslateValues[] = [];

  const token = localStorage.getItem(USER_TOKEN);

  const options = {
    languageId: activeLanguageId,
    defaultLanguageId,
    include: JSON.stringify([{ association: "language" }, { association: "user" }]),
  };

  if (token && activeLanguageId && defaultLanguageId) {
    try {
      const response = await API.get(`/language/translate/values`, { params: options });
      const responseLanguage = await API.get(`/languages/${activeLanguageId}`);
      language = responseLanguage?.data;
      languageTranslations = response?.data;
    } catch (err) {
      console.error("Error on get translate:", err);
    }
  }

  const databaseFallback = languageTranslations.reduce(
    (translations, translate) => ({ ...translations, [translate.key]: translate.value }),
    {}
  );

  const resources: any = {};

  // Select the appropriate local locale as base, overlaying backend
  const localeMap: Record<string, any> = {
    pt: pt_BR,
    es: es_ES,
    it: it_IT,
    fr: fr_FR,
    zh: zh_CN,
  };
  const storedPrefix = localStorage.getItem(SELECTED_LANGUAGE_PREFIX);
  const resolvedPrefix = language?.prefix || storedPrefix || "";

  const localeTranslations = localeMap[resolvedPrefix] ?? en_US;
  const mergedTranslations =
    databaseFallback && Object.keys(databaseFallback).length > 0
      ? { ...databaseFallback, ...localeTranslations }
      : localeTranslations;

  resources[resolvedPrefix || "en"] = {
    translation: mergedTranslations,
  };

  i18n
    .use(initReactI18next)
    .init({
      resources,
      lng: resolvedPrefix || "en",
      interpolation: {
        escapeValue: false,
      },
    });
};
